import React from "react";

import { SwitchProps } from "./Switch.types";
import * as S from "./Switch.styles";

/**
 * Switch component - A toggle control for binary options
 */
export const Switch = ({
  checked,
  onCheckedChange,
  required,
  label,
  disabled,
  id
}: SwitchProps) => {
  return (
    <S.Layout>
      {label && (
        <S.Label htmlFor={id} disabled={disabled}>
          {label}
        </S.Label>
      )}
      <S.Root
        id={id}
        disabled={disabled}
        checked={checked}
        required={required}
        onCheckedChange={onCheckedChange}
        aria-label="switch-control"
      >
        <S.Thumb />
      </S.Root>
    </S.Layout>
  );
};
